// URLs externes Mindexia (site marketing + outils tiers).
// Centralisé ici pour éviter la duplication et faciliter les mises à jour.
export const EXTERNAL_LINKS = {
  legal: 'https://www.mindexia.fr/legal',
  privacy: 'https://www.mindexia.fr/confidentialite',
  terms: 'https://www.mindexia.fr/cgu-cgv',
  help: 'https://calendly.com/mindexia/echanger',
} as const;
